<template>
	<Modal v-if="display" @hideModal="toggleModal" :wide=true id="packageCardModal">
		
		<h1 class="font-bold text-lg text-left mt-0">
			Added to Cart
		</h1>
		<div class="grid grid-cols-2 md:grid-cols-3 gap-4">

			<div class="col-span-2 md:col-span-2 text-left">
				<img :src="`${urlLocation}/services/lawn-care/service-lawn-care-preferred-program-600x600.webp`"
					style="max-height: 100px; float: left;" class="mr-5" alt="" />

				<h3 v-text="serviceName"></h3>

				<span class="small">
					{{ formatPrice(price) }}
					<span>
						Per Month
					</span>
				</span>
			</div>

			<div class="md:text-right col-span-2 md:col-span-1">
				<NuxtLink to="/cart/" class="button mb-5 "> Go to Cart </NuxtLink>
				<a class="button mb-5 button-white" @click.stop.prevent="toggleModal"> Continue Shopping </a>
			</div>
		</div>

		<div class="pt-5 border-top">
			<div class="pt-2 pb-5 font-bold title">Add Popular Service To Your Order</div>
			<div class="grid grid-cols-1 md:grid-cols-3 px-4 gap-4">

				
				<div class="service-item" v-for="(item, key) in serviceRecord" :key="key">
						<div class="service-image" :style="{ backgroundImage: 'url(' + item.ServiceImage + ')' }">
						</div>

						<div class="flex pt-2 pb-2 justify-between items-baseline">
							<div class="service-name pt-4"> 
							<div>
	
								{{ item.ServiceName }} 
							</div>  
						
							<NuxtLink :to="'/services/' + item.ServiceSlug + '/'"><span style="font-size: 0.75rem;font-weight:bold">Learn more</span></NuxtLink>
						
							</div>
							<span style="width: 35%;text-align: center;">
								<h3 class="txt-00953A m-0">${{ item.mainPrice }}</h3>
								<!-- <span class="price-per-month">Per Month</span> -->
	
								<span v-if="item.isMonthly" class="price-per-month">
									Per Month
								</span>
								<span class="price-per-month" v-else>
									Per visit
								</span>
	
							</span>
						</div>
						<p class="pt-3">
							<a href="#" class="button visible" 
							:class="{ 
								'added-to-cart button-added': addedToCart.length > 0 && addedToCart.indexOf(item.ServiceDefId) > -1, 
								'add-to-cart': !(addedToCart.length > 0 && addedToCart.indexOf(item.ServiceDefId) > -1) 
							}" 
							@click.stop.prevent="addToCart(item, key)"> {{
								(addedToCart.length > 0 && addedToCart.indexOf(item.ServiceDefId) > -1) ? "Added to Cart" :
									"Add to Cart" }} </a>
						</p>
	
				</div>

			</div>
		</div>
      
		<Toast v-if="showToast" @hideToast="toggleToast">{{ message }}</Toast>
	</Modal>
</template>

<script setup lang="ts">
import { useStore } from 'vuex';
import type { Store } from 'vuex/types/index.js';
import Modal from '~/components/Modal.vue';
import type ServiceState from '~/domains/store/services/ServiceState';
import type State from '~/domains/store/State';
import { getFormattedPrice } from '~/utils/payment';

const store: Store<State> = useStore();
const { $config, $services } = useNuxtApp();

const props = defineProps({
	serviceName: {
		type: String,
		required: true
	},
	price: {
		type: Number,
		required: true
	}
});

const serviceRecord = ref<ServiceState[]>([]);
const addedToCart = ref<number[]>([]);
const changeAddon = ref(false);
const display = ref(false);
const urlLocation = ref($config.public.sgCmsImage);
const message = ref('There was a problem. Please try again at another time.');
const showToast = ref(false);

const useStoreServiceData = computed(() => {
	return !!store.state.persistedState.serviceData?.services;
});

const toggleModal = () => {
	display.value = !display.value;
};

const toggleToast = () => {
  showToast.value = !showToast.value;
};

const formatPrice = (value: number) => {
	return getFormattedPrice(value);
};

const loadServicesData = () => {
	const persistedState = store.state.persistedState;
	if (!persistedState) return;

	const { franchiseData } = persistedState;
	const allServiceIds = franchiseData?.services_to_display ?? [];
	const addonUpsellServiceIds = allServiceIds.filter((serviceId) => !["2", "3"].includes(serviceId));
	const addonUpsellServices: ServiceState[] = $services.getServicesByIds(addonUpsellServiceIds, true, false);

	let orderItems = persistedState?.order?.orderItems || [];

	let data = addonUpsellServices.filter(obj => !orderItems.some(item =>
		item.uP_ServiceDefinitionId === obj.ServiceDefId
	));

	serviceRecord.value = data?.slice(0, 3);
};

const addToCart = async (service: ServiceState, key: number) => {
	changeAddon.value = true;

	let response;
	if (useStoreServiceData.value) {
		response = await $services.addServiceToCart(service);
	}

	if (response?.successful) {
		addedToCart.value.push(service.ServiceDefId);
	} else {
		message.value = response?.message || 'There was a problem. Please try again at another time.';
		showToast.value = true;
	}
};

watch(
	() => store.state.persistedState.order,
	(newVal, oldVal) => {
		if (!changeAddon.value) {
			loadServicesData();
		}
	},
	{ deep: true, immediate: true }
);


onMounted(() => {
	loadServicesData();
});



function show() {
  display.value = true;
}

function closeModal() {
  display.value = false;
}

defineExpose({
  show,
  closeModal
});

</script>

<style scoped>
.txt-00953A {
	color: #00953A;
}

.border-top {
	border-top: 1px solid #517195;
}

.title {
	font-size: 1.2rem;
}


.service-item {
	/* max-width: 250px; */
}

.service-image {
	background-size: cover;
	background-repeat: no-repeat;
	background-position: bottom center;
	height: 175px;
	border-radius: 1rem;
	min-width: 250px;
	margin: 0 auto;
}

.flex {
	display: flex;
}

.justify-between {
	justify-content: space-between;
}

.items-baseline {
	align-items: baseline;
}

.service-name {
	font-size: 1rem;
	font-weight: 600;
}

.price-per-month {
	font-size: 0.7rem;
}

.txt-00953A {
	color: #00953A;
}

.add-to-cart {
	display: inline-block;
	max-width: 8rem;
	font-size: 0.75rem;
	padding: 5px;
	text-align: center;
	background-color: #00953A;
	color: white;
	border-radius: 0.5rem;
	text-decoration: none;
}

.added-to-cart {
	display: inline-block;
	max-width: 8rem;
	font-size: 0.75rem;
	padding: 5px;
	text-align: center;
	background-color: #fff;
	color: #00953A;
	border-radius: 0.5rem;
	text-decoration: none;
	border: 1px solid #00953A;
}
</style>
